<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loading"
      :variant="'white'"
      :opacity="0.7"
      :blur="'2px'"
      rounded="sm"
      no-wrap
    />
    <div
      v-if="!format"
      class="form-group col-6"
    >
      <label
        class="required"
        style="margin-top: 1em;"
      >
        {{ $t('resource.datastore.format.label') }}
      </label>
      <ValidationProvider
        v-slot="{ classes, errors }"
        :name="`Datastore format ${usedFor}`"
        :rules="`${resource.isNotEmpty() ? 'required' : ''}`"
      >
        <div
          class="control"
          :class="classes"
        >
          <Multiselect
            v-model="form.format"
            :options="formatOptions"
            :class="resource.isNotEmpty() ? classes : ''"
            track-by="value"
            label="label"
            select-label=""
            selected-label=""
            deselect-label=""
            :searchable="false"
            :placeholder="$t('resource.datastore.format.placeholder')"
            @select="selectFormat"
          />
          <span class="form-errors">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
    </div>
    <div class="form-group col-12">
      <label
        class="required"
        style="margin-top: 1em;"
      >
        {{ $t('resource.datastore.database.label') }}
      </label>
      <ValidationProvider
        v-slot="{ classes, errors }"
        :name="`Datastore name ${usedFor}`"
        :rules="`${resource.isNotEmpty() ? 'required' : ''}`"
      >
        <div
          class="control"
          :class="classes"
        >
          <Multiselect
            v-model="form.namespace"
            :loading="datastoreLoading"
            :options="datastoresList"
            :class="resource.isNotEmpty() ? classes : ''"
            :disabled="!(form.format && datastoresList.length)"
            track-by="url"
            label="label"
            select-label=""
            selected-label=""
            deselect-label=""
            :preselect-first="false"
            :allow-empty="true"
            :searchable="false"
            :placeholder="$t('resource.datastore.database.placeholder')"
            @select="selectDatastore"
          />
          <span class="form-errors">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
    </div>
    <!-- TABLE -->
    <div 
      v-if="form.format"
      class="form-group col-12" 
    >
      <label
        class="required"
        style="margin-top: 1em;"
      >
        {{ $t('resource.datastore.table.label') }}
      </label>
      <SearchDatastoreTables
        :loading="tableLoading"
        :table="selectedTable"
        :disabled="!(form.namespace && datastoreTables.length)"
        :required="resource.isNotEmpty()"
        :used-for="usedFor"
        :datastore-tables="datastoreTables"
        :type="form.format.type"
        :datastore="form.namespace.label"
        :placeholder="$t('resource.datastore.table.placeholder')"
        @select="selectDatastoreTable"
      />
      <p class="label-help">
        {{ $t('resource.datastore.table.help') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import Multiselect from 'vue-multiselect';
import SearchDatastoreTables from '@/components/Searchbars/SearchDatastoreTables';

import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import datastoreAPI from '../../../api/modules/resource/datastore.api';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'DatastoreCreator',

  components: {
    SearchDatastoreTables,
    Multiselect,
    ValidationProvider
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => ({})
    },
    usedFor: {
      type: String,
      default: 'resource'
    },
    format: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: false,
      datastoreLoading: false,
      tableLoading: false,
 
      form: {
        type: 'datastore',
        format: null,
        namespace: null,
        table_name: null,
        schema_name: null,
      },
      selectedTable: null,
      datastoreTables:[],
      formatOptions: [
        { value: 'postgres', label: 'PostgreSQL', type: 'datapusher' },
        { value: 'postgis', label: 'PostGIS', type: 'geospatial' }
      ],
      schemaOptions: [],
      tableOptions: [],
    };
  },

  computed: {
    ...mapState('resources/datastore', [
      'datastoresList',
     
    ]),

    isGeospatial() {
      return this.form.format && this.form.format.value === 'postgis';
    }
  },

  watch: {

    'form.format.value': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedTable = null;
        this.form.table_name = null;
        this.form.namespace = null;
      }
    },

    format(newValue) {
      if (newValue) {
        this.form.format = this.formatOptions.find(el => el.value === newValue);
        this.selectFormat(this.form.format);
      }
    },

    form: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue.format.value !== oldValue.format.value) {
          this.form.namespace = null;
        }
       
        
      }
    },
  },

  created() {
 
   
    if (this.format) {
      this.form.format = this.formatOptions.find(el => el.value === this.format);
      this.selectFormat(this.form.format);
    }
  },
  mounted(){
    
  },
  methods: {
    ...mapMutations('resources/datastore', [
      'SET_SELECTED_DATASTORE'
    ]),
    ...mapActions('resources/datastore', [
      'GET_DATASTORES_LIST',
    ]),

    selectFormat(e) {
      console.log(e);
      if (e.type) {
        this.resource.type=e.value;
        this.resource[e.value]={};
        this.datastoreLoading = true;
        this.GET_DATASTORES_LIST(e.type)
          .then(() => {
            if (this.datastoresList && this.datastoresList.length) {
              this.form.namespace = this.datastoresList[0];
              this.selectDatastore(this.datastoresList[0]);
            }
            this.datastoreLoading = false;
          })
          .catch(() => {
            this.datastoreLoading = false;
          });
      }
    },
    selectDatastore(e) {
      this.SET_SELECTED_DATASTORE(e);
      this.resource[this.resource.type].database_ns=e.label;
      if (e.url) {
        this.tableLoading = true;
        console.log(e);
        datastoreAPI.getTablesList(this.form.format.type,e.label)
          .then((tables) => {
            this.datastoreTables=tables.map(el => {
              return { ...el, label: `${el.schema_name}.${el.table_name}` };
            });
            this.tableLoading = false;
          })
          .catch((err) => {
            console.error(err);
            this.tableLoading = false;
          });
      }
    },

    selectDatastoreTable(e) {
      this.selectedTable = e;
      if (e) {
        this.resource[this.resource.type].schema_name=e.schema_name;
        this.resource[this.resource.type].table_name=e.table_name;
        this.form.schema_name = e.schema_name;
        this.form.table_name = e.table_name;
      } else {
        this.form.schema_name = null;
        this.form.table_name = null;
        this.resource[this.resource.type].schema_name=null;
        this.resource[this.resource.type].table_name=null;
      }
    }
  }
};
</script>
